import {
    Avatar,
    Navbar,
    NavbarItem,
    NavbarSection,
    NavbarSpacer,
    Dropdown,
    DropdownButton,
} from '../components'
import { AppNavMenu } from './AppNavMenu'
import profileImage from "../assets/images/users/erica.jpg";

export function AppNavBar({ events, children }) {
    return (
        <Navbar>
            <NavbarSpacer />
            <NavbarSection>
                <Dropdown>
                    <DropdownButton as={NavbarItem}>
                        <Avatar src={profileImage} square />
                    </DropdownButton>
                    <AppNavMenu anchor="bottom end" />
                </Dropdown>
            </NavbarSection>
        </Navbar>
    );
};